module.exports = __webpack_public_path__ + "static/exo-protected-bcfa229da42bee2d692accca12aa833f.jpg";